export {UvpDetailsView} from "./uvp-details.view";
